import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { forbidExtraProps } from 'airbnb-prop-types';

import { Route, Routes } from 'react-router';

import { connect } from 'react-redux';

import RequireAuth from 'Components/RequireAuth';

import * as membershipActions from 'dux/membership/actions';
import * as subscriptionActions from 'dux/subscriptions/actions';
import * as userSelectors from 'dux/user/selectors';

import MembershipScene from './MembershipScene';
import ProductSelection from './ProductSelection';

const MembershipRoutes = ({ hasSubscription, fetchMembership, fetchSubscription }) => {
  useEffect(() => {
    if (hasSubscription) {
      fetchMembership();
      fetchSubscription();
    }
  }, [hasSubscription]);

  return (
    <Routes>
      <Route element={<MembershipScene />} index />
      <Route
        element={
          <RequireAuth>
            <ProductSelection />
          </RequireAuth>
        }
        path="choose-product"
      />
    </Routes>
  );
};

MembershipRoutes.propTypes = forbidExtraProps({
  hasSubscription: PropTypes.bool.isRequired,
  fetchMembership: PropTypes.func.isRequired,
  fetchSubscription: PropTypes.func.isRequired,
  membershipRawData: PropTypes.shape({}),
});

MembershipRoutes.defaultProps = {
  membershipRawData: null,
};

const ConnectedMembershipRoutes = connect(
  state => ({
    hasSubscription: userSelectors.getHasSubscription(state),
  }),
  {
    fetchMembership: membershipActions.fetchMembership,
    fetchSubscription: subscriptionActions.fetchSubscriptions,
  }
)(MembershipRoutes);

export default ConnectedMembershipRoutes;
